import React from 'react';
import Link from 'next/link';
import { Routes, serviceNowSupportUrl } from '../../../common';
import { Logo } from './NewLogo';
import { BruktbilLogo } from './BruktbilLogo';
import { SalesPerson } from './SalesPerson';
import { isNil } from 'lodash';
import { LagerListVisningLogo } from './LagerListVisningLogo';
import { Icon, IconType } from '@repo/ui/components';
import OfferTypeBadge from '@components/layout/AppHeader/OfferTypeBadge';
import { OrderCreationType } from 'next-common';
import { useAppSelector } from '@store/hooks';
import { selectOrderType } from '@store/selectors';
import { cn } from 'types';

interface IAppHeaderProps {
  isUsedCar: boolean;
  OrderType?: OrderCreationType;
}
interface IMenuProps {
  isStockListingPage: boolean;
}
interface IMenuLinkProps {
  active: boolean;
  menuIcon: IconType;
  title: string;
  route?: string;
  serviceNowSupportUrl?: string;
  target?: string;
}
interface ILogoLinkProps {
  isUsedCar: boolean;
  isStockListingPage?: boolean;
  orderType?: OrderCreationType;
}

const LogoLink = ({ isUsedCar, isStockListingPage, orderType }: ILogoLinkProps) => {
  const rxOrderType = useAppSelector(selectOrderType) as OrderCreationType;
  const RenderLogo = () => {
    switch (true) {
      case isUsedCar:
        return <BruktbilLogo />;
      case isStockListingPage:
        return <LagerListVisningLogo />;
      default:
        return <Logo />;
    }
  };

  return (
    <div className="flex items-center">
      <div className="flex gap-6">
        <Link href={Routes.getHomePage()}>
          <div className="shrink-0 w-full">
            <RenderLogo />
          </div>
        </Link>

        {(orderType || rxOrderType) && (
          <div className="flex items-end relative top-1">
            <OfferTypeBadge type={orderType ?? rxOrderType} />
          </div>
        )}
      </div>
    </div>
  );
};

const MenuLink = (props: IMenuLinkProps) => {
  const { menuIcon, title, route, serviceNowSupportUrl, target = '_self' } = props;
  return (
    <span className="flex gap-2 items-center text-white cursor-alias-pointer px-4 py-3">
      <Icon icon={menuIcon} aria-hidden height={24} width={24} fill="var(--color-white)" />
      {isNil(serviceNowSupportUrl) ? (
        <Link href={route} target={target} className="text-base/[175%] font-semibold">
          {title}
        </Link>
      ) : (
        <a href={serviceNowSupportUrl} target="_blank" className="text-base/[175%] font-semibold">
          {title}
        </a>
      )}
    </span>
  );
};

const Menu = ({ isStockListingPage }: IMenuProps) => {
  const isHomePage = () => window.location.pathname === Routes.getHomePage(); //is marginer page
  return (
    <div className="flex items-center gap-10">
      {!isStockListingPage && (
        <MenuLink
          active={isHomePage()}
          route={Routes.getHomePage()}
          title="Min oversikt"
          menuIcon={IconType.NewNextList}
        />
      )}
      {/* need to enable after 8th dec prod release */}
      {/* {pathname.includes(Routes.getSalesWizardPage()) && (
        <MenuLink
          active={isHomePage()}
          route={Routes.getStockListingRoute()}
          title="Nye biler på lager"
          menuIcon={IconType.CarSide}
          target="_blank"
        />
      )} */}
      <MenuLink
        active={isHomePage()}
        title="Support"
        menuIcon={IconType.NewNextSupport}
        serviceNowSupportUrl={serviceNowSupportUrl}
      />
      <SalesPerson />
    </div>
  );
};

const AppHeader = (props: IAppHeaderProps) => {
  const isStockListingPage = window.location.pathname === Routes.getStockListingRoute();

  return (
    <div
      className={cn(
        'flex items-center justify-between px-12 py-2 h-header',
        isStockListingPage ? 'bg-concrete' : 'bg-ultramarine'
      )}
    >
      <LogoLink isUsedCar={props.isUsedCar} isStockListingPage={isStockListingPage} orderType={props?.OrderType} />
      <Menu isStockListingPage={isStockListingPage} />
    </div>
  );
};

export default AppHeader;
